<ion-content [fullscreen]="true">
  <ion-refresher id="refresher" slot="fixed" (ionRefresh)="doRefresh($event)" [disabled]="isBrowser">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <ion-grid *ngIf="!showNoAnlegg">
    <ion-row>
      <ion-col>
        <app-info-varsling-popup *ngFor="let i = index; let message; of: infoMessages" [popupId]="i"
          [message]="message"></app-info-varsling-popup>
      </ion-col>
    </ion-row>
    <ion-row class="forbruk-row-width">
      <ion-col size="12">
        <ion-row>
          <ion-col>
            <ion-title>
              <!-- Strømforbruk -->
              <h1>Strøm&#173;forbruk</h1>
            </ion-title>
          </ion-col>
        </ion-row>

        <!-- Anlegg -->
        <app-anlegg [_showAnleggsliste]="_showAnleggsliste" [anleggList]="anleggList" [valgtAnlegg]="valgtAnlegg"
          [anleggIsInactive]="anleggIsInactive" [mineAvtaler]="mineAvtaler"
          (outAnlegg)="setAnlegg($event)"></app-anlegg>

        <!-- VIEW BUTTONS -->
        <app-viewpicker></app-viewpicker>

        <!-- DATEPICKER / PERIODE -->
        <app-datepicker [minDate]="minDate" [maxDate]="maxDate" [selectedDateMonth]="selectedDateMonth"
          [selectedDateDay]="selectedDateDay" [selectedDateHour]="selectedDateHour" [startDate]="startDate"
          (emitSelectedDateDay)="setSelectedDateDay($event)" (emitSelectedDateHour)="setSelectedDateHour($event)"
          (emitSelectedDateMonth)="setSelectedDateMonth($event)" (emitUpdateChart)="updateChart()"></app-datepicker>

        <!-- NØKKELTALL TOPP -->
        <app-nokkeltall [valgtAvtale]="valgtAvtale" [valgtAnleggAar]="valgtAarAnlegg"
          [valgtAnleggMaaned]="valgtMaanedAnlegg" [valgtAnlegg]="valgtDagAnlegg" [valgtTimeAnlegg]="valgtTimeAnlegg"
          [selectedDateMonth]="selectedDateMonth" [selectedDateDay]="selectedDateDay"
          [selectedDateHour]="selectedDateHour" [_foretakMap]="_foretakMap"
          [isStromstotteToggled]="isStromstotteToggled" [isBrowser]="isBrowser"></app-nokkeltall>
      </ion-col>
    </ion-row>

    @if (_chartTypes && (_chartTypes.Time.active || _chartTypes.Dag.active)) {
    <ion-row class="forbruk-row-width mt-3">
      <ion-col class="flex justify-center">
        <ion-button class="green" (click)="goToAnalyse()">
          Se din strømanalyse
          <ion-icon name="arrow-forward-outline"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
    }

    <!-- GRAFER -->
    <app-graphs *ngIf="valgtAnleggHasData && !hasFetchingError; else noDataTemplate"
      [availableYearsForbruk]="availableYearsForbruk" [selectedYearsForbrukMonth]="selectedYearsForbrukMonth"
      [hasFetchingError]="hasFetchingError" [valgtAarAnlegg]="valgtAarAnlegg" [valgtMaanedAnlegg]="valgtMaanedAnlegg"
      [valgtDagAnlegg]="valgtDagAnlegg" [valgtTimeAnlegg]="valgtTimeAnlegg" [minDate]="minDate"
      [selectedDateDay]="selectedDateDay" [selectedDateMonth]="selectedDateMonth" [selectedDateHour]="selectedDateHour"
      [valgtAvtale]="valgtAvtale" [isBrowser]="isBrowser" [_foretakMap]="_foretakMap"
      (selectedYearsForbrukMonthChange)="selectYearForbrukMonth($event)"
      (selectedDateMonthChange)="setSelectedYear($event)" [isStromstotteToggled]="isStromstotteToggled"></app-graphs>

    <!-- Export-->
    <ion-row class="forbruk-graphs-container-row m-t-b">
      <ion-col size="12" offset="0" size-sm="8" offset-sm="2" size-lg="8" offset-lg="2" size-xl="6" offset-xl="3">
        <ion-row *ngIf="anleggList">
          <ion-col size="12">
            <div class="downloadInfo">
              <ion-button strong="true" class="dark wide" (click)="downloadInfo(1)"><ion-icon slot="start"
                  name="download-outline"></ion-icon><b>Eksporter forbruk</b></ion-button>
            </div>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>

    <!-- GRAF FORKLARING -->
    <app-graphtext [showNoAnlegg]="showNoAnlegg" [activeGraphDescription]="activeGraphDescription"></app-graphtext>
  </ion-grid>

  <!-- INGEN ANLEGG TILGJENGELIG -->
  <ion-grid *ngIf="showNoAnlegg">
    <ion-row>
      <ion-col>
        <ion-row>
          <ion-col>
            <ion-title>
              <!-- Strømforbruk -->
              <div>Strøm&#173;forbruk</div>
            </ion-title>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="ingen-avtale-boks mt-4">
            <p>Vi finner ingen aktive avtaler for din bruker.</p>
            <p *ngIf="fremtidigeAvtaler?.length > 0">
              Du har {{ fremtidigeAvtaler?.length || '?' }} anlegg som starter
              opp. Første starter {{ fremtidigeAvtaler[0].fradato | date:
              'dd.MM.yyyy' }}.
            </p>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-grid>
  <!-- Feedback link/button in bottom right corner -->
  <app-feedback></app-feedback>
  <div class="tab-content-bottom-margin"></div>
</ion-content>

<ng-template #noDataTemplate>
  <ion-row class="forbruk-row-width">
    <ion-col class="md:ml-3">
      <div class="error-container">
        <p class="errorMessage" *ngIf="hasFetchingError">
          Klarte ikke hente data. Prøv igjen senere eller kontakt oss om
          problemet vedvarer.
        </p>
        <p class="errorMessage" *ngIf="!hasFetchingError && !valgtAnleggHasData">
          Vi finner dessverre ingen forbruksdata for dette anlegget på den
          valgte datoen.
        </p>
      </div>
    </ion-col>
  </ion-row>
</ng-template>